module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"text-nowrap\"> ")
    ;  if(locals.estDeliveryDate) { 
    ; __append(" ")
    ; __append(escapeFn( locals.estDeliveryDate ))
    ; __append(" <div> <small class=\"text-muted hidden-xs\"> ")
    ;  if(locals.originalEstimate && locals.originalEstimate != locals.estDeliveryDate) { 
    ; __append(" original: ")
    ; __append(escapeFn( locals.originalEstimate ))
    ; __append(" ")
    ;  } else { 
    ; __append(" &nbsp; ")
    ;  } 
    ; __append(" </small> </div> ")
    ;  } else { 
    ; __append(" <small class=\"text-muted\">(None)</small> ")
    ;  } 
    ; __append(" </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/delayed_trackers/delivery_date.ejs
// module id = 798
// module chunks = 1